import React from 'react';
import Notibar from './Notibar';
const Homescreen = () =>{
    return(
        <div className="screen-wrapper">
            <div className="screen-internal-wrapper">
                <Notibar/>
            </div>
        </div>
    );
}
export default Homescreen;